export default __webpack_public_path__ + "static/embark-roadmap-np-b5b732ceadd4c4fa39e155b2f0ea8fb7.webp";